import React from 'react';
import { Link } from 'react-router-dom';

const content = {
  terms: {
    title: 'Terms of Use',
    intro: 'FashionMate is a personal styling assistant. Recommendations are suggestions, not guarantees of fit, safety, availability, or suitability.',
  },
  privacy: {
    title: 'Privacy and AI Data Use',
    intro: 'FashionMate uses closet details, style preferences, outfit history, and prompts to provide personalized recommendations.',
  },
};

const Legal = ({ type }) => {
  const page = content[type] || content.terms;
  return (
    <main className="legal-shell">
      <Link to="/login" className="legal-brand">FM FashionMate AI</Link>
      <article className="legal-card glass-panel-heavy">
        <h1>{page.title}</h1>
        <p>{page.intro}</p>
        <h2>How the service works</h2>
        <p>Closet photos may be analyzed by an AI service to identify clothing attributes. You review detected items before saving them. The AI Stylist may consult your saved closet and style preferences, and may use external context such as weather only when you request it.</p>
        <h2>Your choices</h2>
        <p>You can edit or remove closet items, style preferences, outfit history, and social content. Avoid uploading images or prompts that contain information you do not want processed by the service.</p>
        <h2>AI limitations</h2>
        <p>AI output can be incomplete or incorrect. Confirm important details such as dress codes, weather, garment care, and fit before acting on a recommendation.</p>
        <p className="legal-updated">Last updated July 17, 2026.</p>
      </article>
    </main>
  );
};

export default Legal;
